import { useLocation } from 'react-router-dom';
import { getNavItemByPath, NavItem } from '@/config/navigationConfig';

export const useCurrentNavItem = (): NavItem | undefined => {
  const location = useLocation();
  return getNavItemByPath(location.pathname);
};
